import {
  CARACTERISTICA_PEDIDO_CREATE,
  CARACTERISTICA_PEDIDO_DELETE,
  CARACTERISTICA_PEDIDO_LOAD,
  CARACTERISTICA_PEDIDO_UPDATE,
  CARACTERISTICA_PEDIDO_LIST
} from "../actions/caracteristicaPedido";
import { ERRORS_SHOW } from "../actions/errors";
import Api from "../../service/api-web";

const state = { list: [] };

const getters = {
  getListCaracteristicasPedido: state => state.list || []
};

const actions = {
  [CARACTERISTICA_PEDIDO_CREATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido.caracteristic
        .adiciona(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_PEDIDO_DELETE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido.caracteristic
        .remove(getters.getFornecedorId, payload)
        .then(resolve)
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_PEDIDO_LOAD]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido.caracteristic
        .get(getters.getFornecedorId, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_PEDIDO_UPDATE]: ({ dispatch, getters }, payload) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido.caracteristic
        .atualiza(getters.getFornecedorId, payload.idcaracteristica, payload)
        .then(resp => resolve(resp.data))
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  },
  [CARACTERISTICA_PEDIDO_LIST]: ({ dispatch, commit, getters }) => {
    return new Promise((resolve, reject) => {
      Api.v4.pedido.caracteristic
        .list(getters.getFornecedorId)
        .then(resp => {
          commit(CARACTERISTICA_PEDIDO_LIST, resp.data);
          resolve(resp);
        })
        .catch(err => {
          dispatch(ERRORS_SHOW, err);
          reject(err);
        });
    });
  }
};

const mutations = {
  [CARACTERISTICA_PEDIDO_LIST]: (state, payload) => {
    state.list = payload || [];
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
